import { getNextLimit } from 'Global/Helpers/appHelpers'

import { SIGN_OUT } from 'Global/Stores/auth'

import { APPLY_EXTENDED_FILTERS, APPLY_FILTERS, RESET_EXTENDED_FILTERS, RESET_FILTERS } from 'Modules/SearchModule/actionTypes'

import { FAMILY_ALBUM_FILTERS_SET } from 'Global/Stores/familyAlbum'

const LAYOUT_SET = 'LAYOUT/SET'
const LAYOUT_SET_ALL = 'LAYOUT/SET/ALL'
const LAYOUT_TOGGLE = 'LAYOUT/TOGGLE'

const LIMIT_TOGGLE = 'LIMIT/TOGGLE'

const PAGE_SET = 'PAGE/SET'

const SORT_BY_SET = 'SORT_BY/SET'
const SORT_BY_SET_ALL = 'SORT_BY/SET/ALL'

const SORT_ORDER_SET = 'SORT_ORDER/SET'
const SORT_ORDER_SET_ALL = 'SORT_ORDER/SET/ALL'
const SORT_ORDER_TOGGLE = 'SORT_ORDER/TOGGLE'

export const layoutSetAll = layout => ({
  payload: layout,
  type: LAYOUT_SET_ALL,
})

export const sortBySetAll = sortBy => ({
  payload: sortBy,
  type: SORT_BY_SET_ALL,
})

export const sortOrderSetAll = sortOrder => ({
  payload: sortOrder,
  type: SORT_ORDER_SET_ALL,
})

export const makeLayoutSet = module => layout => ({
  meta: { module },
  payload: layout,
  type: LAYOUT_SET,
})

export const makeLayoutToggle = module => () => ({
  meta: { module },
  type: LAYOUT_TOGGLE,
})

export const makeLimitToggle = module => () => ({
  meta: { module },
  type: LIMIT_TOGGLE,
})

export const makePageSet = module => page => ({
  meta: { module },
  payload: page,
  type: PAGE_SET,
})

export const makeSortBySet = module => sortBy => ({
  meta: { module },
  payload: sortBy,
  type: SORT_BY_SET,
})

export const makeSortOrderSet = module => sortOrder => ({
  meta: { module },
  payload: sortOrder,
  type: SORT_ORDER_SET,
})

export const makeSortOrderToggle = module => () => ({
  meta: { module },
  type: SORT_ORDER_TOGGLE,
})

const defaulModuleState = {
  layout: 'gridLayout',
  limit: 36,
  page: 1,
  sortBy: 'id',
  sortOrder: 'descending',
}

const initialState = {
  designerQueue: defaulModuleState,
  familyAlbum: defaulModuleState,
  groups: { ...defaulModuleState, sortBy: 'name', sortOrder: 'ascending' },
  markedForDesigners: defaulModuleState,
  myOrders: defaulModuleState,
  requestedRugs: defaulModuleState,
  search: defaulModuleState,
}

const reducer = (state = initialState, action) => {
  const { meta, payload, type } = action

  switch (type) {
    // Internal

    case LAYOUT_SET:
      if (meta && meta.module) {
        return {
          ...state,
          [meta.module]: {
            ...state[meta.module],
            layout: payload,
          },
        }
      }

      return state

    case LAYOUT_SET_ALL:
      return {
        ...state,
        designerQueue: {
          ...state.designerQueue,
          layout: payload,
        },

        familyAlbum: {
          ...state.familyAlbum,
          layout: payload,
        },

        markedForDesigners: {
          ...state.markedForDesigners,
          layout: payload,
        },

        myOrders: {
          ...state.myOrders,
          layout: payload,
        },

        requestedRugs: {
          ...state.requestedRugs,
          layout: payload,
        },

        search: {
          ...state.search,
          layout: payload,
        },
      }

    case LAYOUT_TOGGLE:
      if (meta && meta.module) {
        if (state[meta.module].layout === 'gridLayout') {
          return {
            ...state,
            [meta.module]: {
              ...state[meta.module],
              layout: 'tableLayout',
            },
          }
        } else {
          return {
            ...state,
            [meta.module]: {
              ...state[meta.module],
              layout: 'gridLayout',
            },
          }
        }
      }

      return state

    case LIMIT_TOGGLE:
      if (meta && meta.module) {
        return {
          ...state,
          [meta.module]: {
            ...state[meta.module],
            limit: getNextLimit(state[meta.module].limit),
            page: 1,
          },
        }
      }

      return state

    case PAGE_SET:
      if (meta && meta.module) {
        return {
          ...state,
          [meta.module]: {
            ...state[meta.module],
            page: payload,
          },
        }
      }

      return state

    case SORT_BY_SET:
      if (meta && meta.module) {
        return {
          ...state,
          [meta.module]: {
            ...state[meta.module],
            page: 1,
            sortBy: payload,
          },
        }
      }

      return state

    case SORT_BY_SET_ALL:
      return {
        ...state,
        designerQueue: {
          ...state.designerQueue,
          sortBy: payload,
        },

        familyAlbum: {
          ...state.familyAlbum,
          sortBy: payload,
        },

        markedForDesigners: {
          ...state.markedForDesigners,
          sortBy: payload,
        },

        myOrders: {
          ...state.myOrders,
          sortBy: payload,
        },

        requestedRugs: {
          ...state.requestedRugs,
          sortBy: payload,
        },

        search: {
          ...state.search,
          sortBy: payload,
        },
      }

    case SORT_ORDER_SET:
      if (meta && meta.module) {
        return {
          ...state,
          [meta.module]: {
            ...state[meta.module],
            page: 1,
            sortOrder: payload,
          },
        }
      }

      return state

    case SORT_ORDER_SET_ALL:
      return {
        ...state,
        designerQueue: {
          ...state.designerQueue,
          sortOrder: payload,
        },

        familyAlbum: {
          ...state.familyAlbum,
          sortOrder: payload,
        },

        markedForDesigners: {
          ...state.markedForDesigners,
          sortOrder: payload,
        },

        myOrders: {
          ...state.myOrders,
          sortOrder: payload,
        },

        requestedRugs: {
          ...state.requestedRugs,
          sortOrder: payload,
        },

        search: {
          ...state.search,
          sortOrder: payload,
        },
      }

    case SORT_ORDER_TOGGLE:
      if (meta && meta.module) {
        if (state[meta.module].sortOrder === 'ascending') {
          return {
            ...state,
            [meta.module]: {
              ...state[meta.module],
              page: 1,
              sortOrder: 'descending',
            },
          }
        } else {
          return {
            ...state,
            [meta.module]: {
              ...state[meta.module],
              page: 1,
              sortOrder: 'ascending',
            },
          }
        }
      }

      return state

    // External

    case APPLY_EXTENDED_FILTERS:
      return {
        ...state,
        search: {
          ...state.search,
          page: 1,
        },
      }

    case APPLY_FILTERS:
      return {
        ...state,
        search: {
          ...state.search,
          page: 1,
        },
      }

    case FAMILY_ALBUM_FILTERS_SET:
      return {
        ...state,
        familyAlbum: {
          ...state.familyAlbum,
          page: 1,
        },
      }

    case RESET_EXTENDED_FILTERS:
      return {
        ...state,
        search: {
          ...state.search,
          page: 1,
        },
      }

    case RESET_FILTERS:
      return {
        ...state,
        search: {
          ...state.search,
          page: 1,
        },
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
